const en = {
	sidebar: {
		userInfo: 'User Information',
		submitForm: 'Submit Self-Declaration',
		submissionStatus: 'Submission Status',
		downloadManual: 'Download User Manual',
		signOut: 'Sign Out',
		selectForm: 'Select Form',
		formFor2568: 'Form for 2025 Notification',
		selectVersion: 'Please select version',
		cancel: 'Cancel',
		download: 'Download',
		newVersion: 'New Version Available',
		newVersionMsg: (v) => `The system has been updated to version ${v}. Please click the button below to refresh the page or press Shift + F5.`,
		refresh: 'Refresh Page',
	},
	signIn: {
		subtitle: 'For Self-Declaration Applicants',
		nationalID: 'National ID Card Number',
		password: 'Password',
		nationalIDRequired: 'Please enter your national ID card number',
		passwordRequired: 'Please enter your password',
		invalidCredentials: 'National ID or password is incorrect',
		register: 'Register as Operator',
		submit: 'Sign In',
		loading: 'Signing in...',
	},
	registration: {
		title: 'Register on Data Portal',
		nationalID: 'National ID Card Number',
		search: 'Search',
		firstname: 'First Name*',
		lastname: 'Last Name*',
		email: 'Email*',
		phone: 'Phone Number*',
		back: 'Back',
		confirm: 'Confirm Registration',
	},
	registrationModal: {
		successMsg: 'Your registration has been confirmed',
		failMsg: 'This user has already been registered',
		incorrectIdMsg: 'National ID card number not found',
		ok: 'OK',
	},
	form: {
		pageTitle: 'Submit Self-Declaration of Conformity',
		noNewFilesTitle: 'Submit Without New Documents',
		attachFileTitle: 'Attach Additional Documents',
		attachFileContent: 'Are you sure you want to attach documents for self-declaration submission?',
		modifyInfoTitle: 'Update Document Information',
		modifyInfoContent: 'Are you sure you want to submit this updated information?',
		submitTitle: 'Submit Self-Declaration of Conformity',
		submitContentOrg: 'Legal Entity',
		submitContentPerson: 'Natural Person',
		submitContentPrefix: (type) => `You are submitting a self-declaration on behalf of "${type}"`,
		submitContentSuffix: (count) => `* Note: The number of attachments included with this request is ${count} file(s)`,
		submitPreviewLink: 'You can preview the self-declaration before submitting',
		here: 'here',
		continueQuestion: 'Do you want to proceed?',
		submit: 'Submit',
		missingPersonalInfoTitle: 'Incomplete Personal Information',
		missingPersonalInfoText: 'Please verify and update your information in the "User Information" menu (You have not specified a name prefix)',
		missingCompanyInfoTitle: 'Incomplete Company Information',
		missingCompanyInfoText: 'Please verify and update your information in the "User Information" menu (You have not specified a company name prefix)',
		invalidAddressTitle: 'Invalid or Incorrect Address Format',
		invalidAddressText: 'Please verify and update your information in the "User Information" menu and fill in the form correctly',
		processingTitle: 'Processing',
		processingText: 'Please wait...',
		processingFooter: 'Please wait....',
		error400Title: 'Invalid Request Data',
		error500Title: 'System Error',
		error500Text: 'Please try again later',
		error408Title: 'Transaction Timed Out',
		errorCheckStatus: 'Please check your request in the Submission Status menu',
		errorCheckStatusCode: (code) => `Please check your request in the Submission Status menu (error code: ${code})`,
		fileSizeLimitTitle: 'File Size Exceeded',
		fileSizeLimitText: 'Total file size must not exceed 300 MB',
		fileTypeErrorTitle: 'Invalid File Type',
		fileTypeErrorText: 'File type must be PDF only',
		deleteFileTitle: 'Are you sure you want to delete this file?',
		deleteFileText: 'You will not be able to recover this file once deleted',
		deleteFileConfirm: 'Yes, delete this file',
		deleteFileSuccess: 'File Deleted!',
		deleteFileSuccessText: 'Your file has been deleted',
		successTitle: 'Self-Declaration Submitted Successfully',
		infoAlertTitle: 'You can study the relevant announcements and regulations, including detailed submission instructions at',
		noPoaTitle: 'You have not been authorized by the establishment',
		noPoaText: 'You have not been granted authorization or rights to act on behalf of the establishment. You are unable to submit a self-declaration as a legal entity. If you wish to proceed as a legal entity, please contact the system administrator to grant authorization before proceeding.',
		requestAdditionalFileTitle: "Officer's Request for Additional Documents",
		requestModifyInfoTitle: "Officer's Request to Update Information",
		ejectRemarkTitle: "Officer's Rejection Details",
		profileErrorMsg: (menu) => `Address information is incorrect or in wrong format. Please verify and update your information in the "${menu}" menu before filling in the form.`,
		profileErrorMenu: 'User Information',
		profileErrorConfirm: 'Edit Information',
		prefixMap: {
			'นาย': 'Mr.',
			'นาง': 'Mrs.',
			'นางสาว': 'Miss',
			'ท่านผู้หญิง': 'Lady',
			'บริษัท': 'Company',
			'ห้างหุ้นส่วน': 'Partnership',
			'ห้างหุ้นส่วนจำกัด': 'Limited Partnership',
			'อื่นๆ': 'Other',
			'ร้าน': 'Shop',
			'ร้านค้า': 'Store',
		},
	},
	sDocStatusMap: {
		1: 'Pending Review',
		3: 'Under Review',
		4: 'Awaiting Assignment',
		6: 'Rejected',
		8: 'Awaiting Payment',
	},
	manage: {
		pageTitle: 'Self-Declaration Submission Status',
		inProgressTitle: 'Self-Declarations In Progress',
		approvedTitle: 'Approved Self-Declarations',
		colRequestNo: 'Request No.',
		colBrandName: 'Brand Name',
		colProductModel: 'Product Model',
		colSubmitDate: 'Submission Date & Time',
		colApproveDate: 'Approval Date & Time',
		colStatus: 'Status',
		colActivity: 'Activity',
		statusIncomplete: 'Incomplete',
		statusDocAdded: 'Documents Added',
		statusInfoUpdated: 'Information Updated',
		statusModifyDoc: 'Modification Requested',
		statusOverdue: 'Payment Overdue',
		btnDetail: 'Details',
		btnRejectReason: 'View Rejection Reason',
		btnAttachFile: 'Attach Files',
		btnUpdateInfo: 'Update Info',
		btnDownloadCert: 'Download Certificate',
		btnUpdatePayment: 'Update Payment Status',
		btnDownloadBill: 'Download Payment Slip',
		btnRenewBill: 'Renew Payment Slip',
		btnRenewBillDisabledTooltip: 'Cannot process because you have already renewed the payment slip',
		btnCancelRequest: 'Cancel Request',
		btnDownloadReceipt: 'Download Receipt',
		waitTitle: 'Please Wait',
		processing: 'Processing...',
		billInquirySuccess: 'Payment verification successful',
		billInquirySuccessText: 'Your payment has been detected. Please wait for the system to proceed.',
		billInquiryFail: 'Payment not found',
		billInquiryFailText: 'Payment for this item was not found, or data may be delayed. Please wait a moment and try again later.',
		billRenewSuccess: 'Renewal accepted. The payment slip is being sent to SAP.',
		cancelSuccess: 'Request cancelled successfully',
		cancelSuccessText: 'Your self-declaration request has been cancelled.',
		cancelFail: 'Cannot cancel request',
		cancelFailText: 'The system was unable to process this request. Please contact staff.',
		noData: 'No data found',
		loading: 'Processing data, please wait...',
	},
	profile: {
		saveSuccess: 'Information saved successfully',
	},
	profileCard: {
		header: 'Self-Declaration Submitter Details',
		senderTypeLabel: 'User Type',
		normalPerson: 'Natural Person',
		organization: 'Legal Entity',
		shop: 'Shop',
		nationalID: 'National ID Card Number',
		prefix: 'Title / Prefix',
		fullName: 'Full Name',
		shopName: 'Shop Name',
		address: 'Address',
		addressPlaceholder: 'House No. / Building / Village / Alley / Road',
		province: 'Province',
		district: 'District',
		subdistrict: 'Sub-district',
		zipcode: 'Postal Code',
		phone: 'Phone Number',
		companyData: 'Company Information',
		shopData: 'Shop Information',
		branchData: 'Branch Information',
		taxID: 'Tax Identification Number',
		companyPrefix: 'Company Name Prefix',
		shopType: 'Shop Type',
		companyName: 'Organization / Operator Name',
		branchNo: 'Branch Code',
		branchNoPlaceholder: '5-digit Branch Code',
		selectBranch: 'Select Branch',
		savePersonal: 'Save Personal Information',
		saveCompany: 'Save Company Information',
		saveShop: 'Save Shop Information',
		saveBranch: 'Save Branch Information',
		specify: 'Specify',
		other: 'Other',
	},
	orgCard: {
		header: '1. Self-Declaration Submitter Details',
		editWarningTitle: 'Editing Submitter Information',
		editWarningMsg: (menu) => `If the details below do not match your current information, you can update them in the "${menu}" menu before submitting the self-declaration.`,
		userInfoMenu: 'User Information',
		senderTypeLabel: 'Submitter Type',
		normalPerson: 'Natural Person',
		organization: 'Legal Entity',
		shop: 'Shop',
		fullName: 'Full Name',
		nationalID: 'National ID Card Number',
		address: 'Address',
		phone: 'Phone Number',
		taxID: 'Tax Identification Number',
		companyPrefix: 'Company Name Prefix',
		shopType: 'Shop Type',
		companyName: 'Organization / Operator Name',
		shopName: 'Shop Name',
		branchNo: 'Branch Code',
		selectBranch: 'Select Branch',
		invalidAddressTitle: 'Address information is incorrect or in wrong format',
		invalidAddressMsg: (menu) => `Please verify and update your information in the "${menu}" menu and fill in the form correctly.`,
		invalidAddressConfirm: 'Edit Information',
		userInfoMenu2: 'User Information',
	},
	brandCard: {
		header: '2. Telecommunications Equipment Details',
		brandName: 'Brand Name',
		model: 'Model',
		description: 'Product Description',
		groupType: 'Telecom Equipment Group Type',
	},
	techType: {
		'ทั่วไป': 'General',
		'RLAN': 'RLAN',
		'RLAN Wifi 6e (ภายในอาคาร)': 'RLAN Wifi 6e (Indoor)',
		'RLAN Wifi 6e (ภายในและภายนอกอาคาร)': 'RLAN Wifi 6e (Indoor & Outdoor)',
		'RFID': 'RFID',
		'Non-RFID': 'Non-RFID',
		'UAS': 'UAS',
		'FOD Vehicle': 'FOD Vehicle',
		'radar': 'Radar',
		'Fix link': 'Fix Link',
		'Optical System': 'Optical System',
		'Studio-Transmitter Link': 'Studio-Transmitter Link',
		'wireless microphone': 'Wireless Microphone',
		'cordless telephone': 'Cordless Telephone',
		'on-site paging (Pocket Unit)': 'On-Site Paging (Pocket Unit)',
		'เครื่องส่งสัญญาณเสียง': 'Audio Transmitter',
		'เครื่องส่งสัญญาณภาพ หรือเครื่องส่งสัญญาณภาพและเสียง': 'Video/Audio Transmitter',
		'ตู้สาขาโทรศัพท์อัตโนมัติ (PABX)': 'PABX',
		'ระบบโทรศัพท์กดปุ่ม (key telephone system)': 'Key Telephone System',
		'บริภัณฑ์ข้อมูลปลายทาง (data terminal equipment)': 'Data Terminal Equipment',
		'เครืองโทรศัพท์ (telephone set)': 'Telephone Set',
		'เครืองโทรสาร (facsimile equipment)': 'Facsimile Equipment',
		'เครืองโทรคมนาคมส่าหรับสายผู้เช่าดิจิทัลแบบต่าง ๆ (xDSL equipment)': 'xDSL Equipment',
		'โมเด็ม (modem)': 'Modem',
	},
	powerUnitMap: {
		'ไม่มี': 'None',
	},
	equipmentCard: {
		header: 'Frequency Band Equipment',
		addButton: 'Add Frequency Band Equipment',
		productType: 'Technology Standard Type',
		frequency: 'Frequency',
		power: 'Transmitted Power',
		unit: 'Unit',
		relatedAnnouncement: 'Related Announcement',
		numberOnly: 'Numbers only',
		invalidNumber: 'Please enter a valid number',
		exactValue: (value) => `Value must equal ${value} dBm`,
		maxValue: (value, unit) => `Value must not exceed ${value} ${unit}`,
		invalidUnit: (units) => `Unit must be ${units}`,
		errorPower: (url) => `***Frequency or transmission power data is incorrect. Please enter the correct transmission power or unit. You can find more details at ${url} or contact us at email: SDoC@nbtc.go.th`,
	},
	documentCard: {
		header: 'Supporting Documents for Self-Declaration',
		subHeader: 'Attached Documents',
		uploadNote: '* Upload files in .pdf format only *',
		downloadAll: 'Download All',
		attachInfo: 'Attachment Information',
		namePlaceholder: 'Please name the document*',
		selectFile: 'Select File',
		noFileSelected: 'No file selected',
		attach: 'Attach File',
		instructions: '* Please attach at least 2 supporting documents\n* Total file size must not exceed 300 MB\n** If the document is a Telecom Equipment Test Report, please name it using the test report number, e.g. Test Report No. : XXXXXXX',
		docName: 'Document Name',
		save: 'Save',
		additionalFile: 'Additional Attachment',
	},
	transactionCard: {
		header: 'Invoice List',
		details: 'Transaction Details',
		colRef1: 'Reference No. 1',
		colRef2: 'Reference No. 2',
		colCreateDate: 'Created Date',
		colDueDate: 'Due Date',
		colReceiveDate: 'Payment Date',
		colInvoiceNo: 'Receipt',
		colStatus: 'Status',
		statusWaiting: 'Awaiting Payment',
		statusExpired: 'Payment Expired',
		statusPaid: 'Paid',
		statusSuccess: 'Completed',
		noData: 'No data found',
		loading: 'Processing data, please wait...',
		addReceiptBtn: 'Add Receipt',
		addReceiptTitle: 'Please enter the receipt number',
		addReceiptPlaceholder: 'Receipt number',
		save: 'Save',
		cancel: 'Cancel',
		addReceiptRequired: 'Please enter the receipt number',
		addReceiptSuccess: 'Receipt number saved successfully',
		errorTitle: 'An error occurred',
		errorRetry: 'Please try again',
		ok: 'OK',
	},
	sureModal: {
		cancel: 'Cancel',
		confirm: 'OK',
		processing: 'Processing...',
		progressLabel: 'Operation progress',
		pleaseWait: 'Please wait, do not close this window while the operation is in progress',
	},
	auth: {
		for: 'For',
		sdocTitle: 'Operator Self-Declaration of Conformity (SDoC)',
		loading: 'Signing in...',
		signInDigitalID: 'Verify Identity via Digital ID to Sign In',
		systemDesc: 'Automated Data Integration System with External Agencies',
		selectOperator: 'Select Operator',
		acknowledged: 'I have read and acknowledged',
		accept: 'Acknowledge',
		updateTokenTitle: 'Update Authorization Data',
		updateTokenPlaceholder: 'Enter the URL received from login',
		updateTokenConfirm: 'Update',
		updateTokenSuccess: 'Data updated successfully',
		maintenanceTitle: 'System Maintenance Notice',
		maintenanceBody: 'The system is temporarily closed for emergency maintenance. We apologize for the inconvenience. NBTC Office will proceed as quickly as possible so that you can submit your service or license requests.',
		maintenanceOrg: 'NBTC Office',
		noPOATitle: 'Please Note',
		noPOAContent: 'You do not have access rights to the SDoC system',
		selectTitle: 'Please Select',
		selectContent: 'You have not yet been granted authorization by the company. In case of incorrect information, please contact an officer at 02-xxx-xxxx',
		taxId: 'Tax ID',
		authPeriod: 'Authorization Period',
		operatorName: 'Operator Name',
		individual: 'Individual',
		select: 'Select',
		viewShop: 'View Shop Information',
		to: 'to',
		noExpiry: 'No Expiration',
		notInSystem: 'Not Found in System',
		noShopTitle: 'No Data Found',
		noShopText: 'No shop data found for your national ID',
		shopErrorTitle: 'Error',
		shopErrorText: 'Unable to retrieve shop data',
		ok: 'OK',
		fetchError: 'Unable to retrieve data, please try again',
		close: 'Close',
		taxIdNumber: 'Tax ID Number',
		companyName: 'Company Name*',
		companyAddress: 'Company Address*',
		reloginRequiredTitle: 'Please Sign In Again',
		reloginRequiredHeader: 'Shop Profile Requires Token Mode',
		reloginRequiredBody: 'Because you signed in using the legacy method (Query String), the system cannot link to shop profile data. Please click "Sign In Again" to authenticate via Service Portal using Token mode.',
		reloginButton: 'Sign In Again',
		cancelButton: 'Cancel',
		back: 'Back',
		confirmRegister: 'Confirm Registration',
	},
}

export default en
